var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112.226,
    height: 49.5,
    viewBox: "0 0 112.226 49.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_152782",
    "data-name": "Group 152782",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_152116",
    "data-name": "Group 152116",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164885",
    "data-name": "Path 164885",
    d: "M141.4,92.714a5.976,5.976,0,0,0-5.711,2.991l.03-2.557H131.63v19.415h4.057V102.048a4.954,4.954,0,0,1,5.238-5.316,6.187,6.187,0,0,1,1.483.163V92.778a7.87,7.87,0,0,0-1.01-.064",
    transform: "translate(-108.264 -73.427)",
    fill: "#003485"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164886",
    "data-name": "Path 164886",
    d: "M486.811,91.714A5.976,5.976,0,0,0,481.1,94.7l.03-2.557h-4.087v19.415H481.1V101.048a4.954,4.954,0,0,1,5.238-5.316,6.189,6.189,0,0,1,1.483.163V91.778a7.873,7.873,0,0,0-1.01-.064",
    transform: "translate(-392.361 -72.635)",
    fill: "#003485"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164887",
    "data-name": "Path 164887",
    d: "M342.9,120.761V92.322h4.03l.027,3.151a8.105,8.105,0,0,1,6.854-3.545c5.79.039,9.808,4.254,9.808,10.123s-3.781,10.123-9.808,10.123c-2.363,0-5.4-.867-6.854-3.269v11.856Zm16.661-18.71a6.125,6.125,0,1,0-12.25,0,6.125,6.125,0,1,0,12.25,0",
    transform: "translate(-282.031 -71.261)",
    fill: "#003485"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164888",
    "data-name": "Path 164888",
    d: "M552.705,69.537v4.408h5.672v3.506h-5.711v9.256c0,2.048.906,3.19,2.8,3.19a5.857,5.857,0,0,0,2.482-.67l1.182,3.466a9.2,9.2,0,0,1-3.9.866c-4.215.118-6.617-2.284-6.617-6.854V77.451h-3.742V73.945h3.742V69.537Z",
    transform: "translate(-448.145 -54.652)",
    fill: "#003485"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_181",
    "data-name": "Line 181",
    y1: 4.117,
    transform: "translate(34.144 18.666)",
    fill: "#003485"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164889",
    "data-name": "Path 164889",
    d: "M10.287,101.533q-.234,0-.469-.008C3.853,101.371,0,97.332,0,91.234v-12.2H4.191v12.2c0,3.85,2.111,6.229,5.646,6.365.141.007.276.011.41.011,3.544,0,5.746-2.443,5.746-6.376v-12.2h4.191v12.2c0,6.257-3.885,10.3-9.9,10.3",
    transform: "translate(0 -62.313)",
    fill: "#003485"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_153023",
    "data-name": "Group 153023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164890",
    "data-name": "Path 164890",
    d: "M225.293,10.935c-11.6,2.168-22.05,9.874-29.168,20.262l-7.5-12.265h-5.19v.235l9.958,16.018-10.38,16.583v.141h5.359l8.059-13.049,8.017,13.049h5.359v-.141L199.385,35.185l-.256-.3c5.691-9.723,14.306-17.485,24.349-20.77,13.125-4.317,27.147-.711,39.273,5.7-11.263-6.9-24.533-11.389-37.459-8.876",
    transform: "translate(-150.525 -8.413)",
    fill: "#ef7710"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164891",
    "data-name": "Path 164891",
    d: "M237.373,6.71a6.709,6.709,0,1,0-9.71,5.994,3,3,0,0,1,3-2.993,3,3,0,1,1,3-3,3,3,0,0,1-3,3,3,3,0,0,1,3,2.993,6.7,6.7,0,0,0,3.708-5.994",
    transform: "translate(-184.199 -0.001)",
    fill: "#ef7710"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.a978d5eb2fa91589f959e39c4caa8116.svg";
export { ForwardRef as ReactComponent };